import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[rmsNamedTemplate]',
  standalone: false
})
export class NamedTemplateDirective {
  @Input('rmsNamedTemplate') name!: string;

  constructor(public template: TemplateRef<any>) {}

}
